import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { environment } from '@env/environment';

export const stoqaAiEnabledGuard: CanMatchFn = () =>
  environment.STOQA_AI_ENABLED ? true : inject(Router).createUrlTree(['/home']);
